var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bkr-cc w-100" }, [
    _vm.localization.shippingCountries.length > 1
      ? _c("div", { staticClass: "input-unit" }, [
          _c(
            "select",
            {
              staticClass: "custom-select form-control",
              on: {
                change: function ($event) {
                  return _vm.setShippingCountry($event.target.value)
                },
              },
            },
            _vm._l(
              _vm.localization.shippingCountries,
              function (shippingCountry) {
                return _c(
                  "option",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.isDisabled,
                        expression: "isDisabled",
                      },
                    ],
                    class: { "is-disabled": _vm.isDisabled },
                    attrs: { disabled: _vm.isDisabled },
                    domProps: {
                      value: shippingCountry.id,
                      selected:
                        _vm.basket.shippingCountryId == shippingCountry.id,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(shippingCountry.currLangName) +
                        "\n                "
                    ),
                  ]
                )
              }
            ),
            0
          ),
          _vm._v(" "),
          _c("label", [
            _vm._v(
              _vm._s(
                _vm.$translate("Ceres::Template.headerSelectShippingCountry")
              )
            ),
          ]),
        ])
      : _c("div", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.getCountryName(_vm.localization.shippingCountryId)) +
              "\n        "
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }